export default __webpack_public_path__ + "static/media/imageBannerFinalSmall.e76a2774.png";